export default __webpack_public_path__ + "static/media/homepage.d826cd5a.png";